// import { Component, Input } from '@angular/core';

// @Component({
//   selector: 'app-adminBotForm',
//   templateUrl: './adminBotForm.component.html',
//   styleUrls: ['./adminBotForm.component.css']
// })
// export class adminBotForm {
//   @Input() orderStep: any
//   @Input() botDetails: any
//   @Input() orderPlaceDet: any
//   @Input() posDetails: any
//   @Input() closeType: any
// }



import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-adminBotForm',
  templateUrl: './adminBotForm.component.html',
  styleUrls: ['./adminBotForm.component.css']
})
export class adminBotForm implements OnChanges {
  @Input() botDetails: any;
  @Input() orderStep: string="";
  @Input() orderPlaceDet: any
  @Input() posDetails: any
  @Input() closeType: any

  ngOnChanges(changes: SimpleChanges) {

    if (changes['botDetails'] && this.botDetails) {
      this.botDetails = changes['botDetails'].currentValue
    }
  }
  goToStep(step: string) {
    this.orderStep = step;
  }
}
